import React, { useEffect } from 'react';
import { getSelectedProduct } from '@americanexpress/product-ducks';
import { FormattedMessage } from 'react-intl';
import { Heading, Layout, Link as DLSLink } from '@americanexpress/dls-react';
import { renderHTML } from '../../../utilities/render-html';
import { BackHeader } from '../../shared/components/BackHeader';
import { Loading } from '../../shared/components/loading';
import Error from '../../shared/components/error';
import style from './terms.css';

export function TermsPage(props) {
  const cardNameValueToUse = props?.cardNameValueToUse;
  const login = props?.login;
  const benefitTerms = props?.benefitTerms;
  const assuranceDisclosures = props?.assuranceDisclosures;

  const header = 'Benefit Terms &#38; Amex Assurance Disclosures';
  const referrer = props?.location?.state?.referrer;
  const actionTag = `${cardNameValueToUse}>>terms`;
  let backHeaderURL = !login ? `/card-benefits/view-all/${cardNameValueToUse}` : '/card-benefits/view-all';
  if (referrer) {
    backHeaderURL = referrer;
  }

  const loadingReadLoyaltyBenefits = props?.loadingReadLoyaltyBenefits;
  const readLoyaltyBenefitsError = props?.readLoyaltyBenefitsError;
  const readLoyaltyBenefits = props?.readLoyaltyBenefits;

  if (loadingReadLoyaltyBenefits) {
    return <Loading />;
  }
  if (readLoyaltyBenefitsError) {
    return <Error />;
  }

  let anchorLabel = '';
  if (global.BROWSER) {
    anchorLabel = window?.location?.hash;
  }
  // eslint-disable-next-line react-hooks/rules-of-hooks -- needed
  useEffect(() => {
    if (anchorLabel === '#disclosures') {
      document.querySelector('#disclosures')?.scrollIntoView();
    }
    if (anchorLabel === '#top') {
      document.querySelector('#top')?.scrollIntoView();
    }
  }, [readLoyaltyBenefits]);

  return (
    <div id="top" data-testid="terms-page">
      <BackHeader title={header} url={backHeaderURL} actionTag={actionTag} />
      <Layout
        aria-label="Benefit Terms and Disclosures Section"
        role="region"
        innerContainerClassName="pad-3-lg-up pad-2 margin-2-t"
      >
        <div>
          <div>
            <Heading level={4} variant="sans-small-regular">
              <br />
              {renderHTML(<FormattedMessage id="BenTerms" defaultMessage="Benefit Terms" />)}
            </Heading>
            <br />
            <div className={style.card}>
              {renderHTML(benefitTerms)}
              <br />
            </div>
            <div id="disclosures">
              {
                anchorLabel === '#disclosures' ? <div><br /><br /><br /><br /><br /><br /><br /></div> : null
              }
            </div>
            <Heading level={4} variant="sans-small-regular">
              <FormattedMessage id="shared.terms-links.disclosures" defaultMessage="AMEX Assurance Company Disclosures" />
            </Heading>
            <br />
            <div className={style.card}>
              {renderHTML(assuranceDisclosures)}
              <br />
            </div>
            <div>
              <DLSLink href="#top">Back to Top</DLSLink>
            </div>
          </div>
        </div>
      </Layout>
    </div>
  );
}

export function mapStateToProps(state) {
  return {
    login: Boolean(getSelectedProduct(state)),
  };
}

export default TermsPage;
